import Controller from './analytics-controller'
import { useIntersection } from 'stimulus-use'

export default class extends Controller {
  options = {
    threshold: 0.25
  }

  isEventSent = false

  connect () {
    useIntersection(this, this.options)
  }

  appear () {
    if (this.isEventSent) return

    this.sendEvent()
    this.isEventSent = true
  }
}
